import { useState } from "react";

const CustomerDetails = () => {
  const [activeTab, setActiveTab] = useState("profile");

  const [formData, setFormData] = useState({
    profileImage: null,
    mobile: '',
    name: '',
    email: '',
    address: '',
    gender: '',
    dob: '',
    anniversary: '',
  });


    const orders = [
    {
      id: "#000000",
      amount: "27.99",
      date: "05 May 2024 - 09:25PM",
      badgeText: "Item: 1",
      imgSrc: "",
    },
    {
      id: "#000001",
      amount: "27.99",
      date: "06 May 2024 - 10:25PM",
      badgeText: "Item: 2",
      imgSrc: "",
    },
  ];

  const transactions = [
  {
    id: "#000000",
    amount: "27.99",
    date: "05 May 2024 - 09:25PM",
  },
  {
    id: "#000001",
    amount: "27.99",
    date: "06 May 2024 - 10:25PM",
  },
];


  const handleChange = (e) => {
    const { name, value, files, type } = e.target;
    if (type === 'file') {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Submitted:', formData);
  };

  return (
    <div className="flex flex-col items-center justify-start min-h-screen  p-4">
      {/* Tab Buttons */}
     <div className="flex flex-wrap justify-center gap-2 mb-6">
  {["profile", "order", "transaction"].map((tab) => (
    <button
      key={tab}
      onClick={() => setActiveTab(tab)}
      className={`px-3 sm:px-4 py-2 rounded-full text-xs sm:text-sm font-medium ${
        activeTab === tab
          ? "bg-primary text-white"
          : "bg-gray-200 text-gray-700"
      }`}
    >
      {tab === "profile" && "Profile"}
      {tab === "order" && "Order History"}
      {tab === "transaction" && "Transaction History"}
    </button>
  ))}
</div>


      {/* Content Based on Active Tab */}
      {activeTab === "profile" && (
        <form
          onSubmit={handleSubmit}
          className="bg-white rounded-lg p-6 w-full max-w-xl space-y-4"
        >
          {/* Profile Picture */}
          <div className="flex flex-col items-center space-y-2">
            <label htmlFor="profileImage" className="cursor-pointer">
              {formData.profileImage ? (
                <img
                  src={URL.createObjectURL(formData.profileImage)}
                  alt="Preview"
                  className="w-24 h-24 rounded-full object-cover"
                />
              ) : (
                <div className="w-24 h-24 rounded-full bg-gray-300 flex items-center justify-center text-gray-600">
                  Upload
                </div>
              )}
            </label>
            <input
              id="profileImage"
              name="profileImage"
              type="file"
              accept="image/*"
              className="hidden"
              onChange={handleChange}
            />
          </div>

          {/* Mobile Number */}
          <input
            type="tel"
            name="mobile"
            placeholder="Mobile Number"
            value={formData.mobile}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2"
            required
          />

          {/* Name */}
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={formData.name}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2"
            required
          />

          {/* Email */}
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2"
          />

          {/* Address */}
          <textarea
            name="address"
            placeholder="Address"
            value={formData.address}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2"
          />

          {/* Gender */}
          <div className="flex items-center space-x-6">
            <label className="flex items-center">
              <input
                type="radio"
                name="gender"
                value="male"
                checked={formData.gender === 'male'}
                onChange={handleChange}
                className="mr-2"
              />
              Male
            </label>
            <label className="flex items-center">
              <input
                type="radio"
                name="gender"
                value="female"
                checked={formData.gender === 'female'}
                onChange={handleChange}
                className="mr-2"
              />
              Female
            </label>
          </div>

          {/* DOB */}
          <input
            type="date"
            name="dob"
            value={formData.dob}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2"
            placeholder="Date of Birth"
          />

          {/* Anniversary */}
          <input
            type="date"
            name="anniversary"
            value={formData.anniversary}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2"
            placeholder="Anniversary"
          />

          {/* Save Button */}
          <button
            type="submit"
            className="w-full bg-primary text-white py-2 px-4 rounded hover:bg-red-700 transition"
          >
            Save
          </button>
        </form>
      )}

     {activeTab === "order" && (
  <div className="bg-white shadow rounded p-4 w-full  text-gray-800">
    {orders.map((order, index) => (
      <div
        key={index}
        className="flex items-start justify-between p-4 bg-white rounded-xl shadow mb-3"
      >
        {/* Left Side: Image and Text */}
        <div className="flex gap-4">
          <img
            src={order.imgSrc || "https://via.placeholder.com/48"}
            alt="Profile"
            className="w-12 h-12 sm:w-14 sm:h-14 rounded-full object-cover"
          />
          <div>
            <div className="font-medium text-sm sm:text-base">{order.id}</div>
            <div className="text-xs text-gray-500">By Store Credit</div>
            <div className="text-xs text-gray-400">{order.date}</div>
          </div>
        </div>

        {/* Right Side: Amount + Badge */}
        <div className="text-right flex flex-col items-end gap-1">
          <div className="font-bold text-green-600 text-sm sm:text-base">
            ${order.amount}
          </div>
          {order.badgeText && (
            <span className="text-[10px] sm:text-xs bg-primary text-red-500 px-2 py-[2px] rounded-full">
              {order.badgeText}
            </span>
          )}
        </div>
      </div>
    ))}
  </div>
)}

    {activeTab === "transaction" && (
  <div className="bg-white shadow rounded p-4 w-full  text-gray-800">
    {transactions.map((txn, index) => (
      <div
        key={index}
        className="flex items-start justify-between p-4 bg-white rounded-xl shadow mb-3"
      >
        {/* Left Side: Code + Date */}
        <div>
          <div className="font-medium text-sm sm:text-base">{txn.id}</div>
          <div className="text-xs text-gray-500">{txn.date}</div>
        </div>

        {/* Right Side: Price */}
        <div className="font-bold text-red-500 text-sm sm:text-base">
          -${txn.amount}
        </div>
      </div>
    ))}
  </div>
)}

    </div>
  );
};

export default CustomerDetails;
